import { Component, OnInit } from '@angular/core';
import { FormaViewModel, SubFormaItemResultsViewModel, SubFormaViewModel } from './grupoforma.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GrupoFormaService } from './grupoforma.service';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-forma-edit-subforma-list',
    templateUrl: './forma-edit-subforma-list.component.html',
    styleUrls: ['./forma-edit-subforma-list.component.scss'],
})

export class FormaEditSubformaListComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nueva Forma';
    forma: FormaViewModel;
    resultSubForma: SubFormaItemResultsViewModel;
    totalregistros: number = 0;
    visibilitySpinner: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private grupoFormaService: GrupoFormaService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.forma = new FormaViewModel();
        this.resultSubForma = new SubFormaItemResultsViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['idForma'];
        this.forma.IdGrupo = this.activatedRoute.snapshot.params['idGrupo'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar Forma';

            this.grupoFormaService.getForma(id).subscribe(result => {
                this.forma = result;
                //this.notificationService.publishBreadCrumb(result.Descripcion, this.router); La quitamos del BreadCrumb-
                this.editTitle += ' - ' + result.Descripcion;
                this.updateForm();
            });
        }

        this.loading = true;
        this.grupoFormaService.getSubFormaByIdForma(id).subscribe(result => {
            this.resultSubForma = result;
            this.totalregistros = this.resultSubForma.ResultList.length;
            this.loading = false;
        });
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            DescripcionIngles: ['', Validators.required],
            TracesProductCode: ['', Validators.required],
            EphytoReinoUnido: [false, Validators.required],
            EspecieSinEppo: [false, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.forma.Descripcion,
            DescripcionIngles: this.forma.DescripcionIngles,
            TracesProductCode: this.forma.TracesProductCode,
            EphytoReinoUnido: this.forma.EphytoReinoUnido,
            EspecieSinEppo: this.forma.EspecieSinEppo,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let forma = new FormaViewModel();

        forma.Descripcion = this.form.value.Descripcion;
        forma.DescripcionIngles = this.form.value.DescripcionIngles;
        forma.TracesProductCode = this.form.value.TracesProductCode;
        forma.EspecieSinEppo = this.form.value.EspecieSinEppo;
        forma.IdGrupo = this.forma.IdGrupo;
        forma.Id = this.forma.Id;
        forma.EphytoReinoUnido = this.forma.EphytoReinoUnido;
        


        if (this.editMode) {
            if (forma.EphytoReinoUnido !== this.form.value.EphytoReinoUnido) {
                this.confirmationService.confirm({
                    message: '¿Quiere aplicar el valor de "Ephyto Reino Unido" a todas las especies asociadas a dicha forma?',
                    accept: () => {
                        forma.EphytoReinoUnido = this.form.value.EphytoReinoUnido;
                        forma.ModifyAllSpecies = true;
                        this.grupoFormaService.editForma(forma).subscribe({
                            next: () => {
                                this.addSuccessMessage('Forma modificada correctamente');
                                this.onBack();
                                this.visibilitySpinner = false;
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                            },
                        });
                    },
                    reject: () => {
                        forma.EphytoReinoUnido = this.form.value.EphytoReinoUnido;
                        forma.ModifyAllSpecies = false;
                        this.grupoFormaService.editForma(forma).subscribe({
                            next: () => {
                                this.addSuccessMessage('Forma modificada correctamente');
                                this.onBack();
                                this.visibilitySpinner = false;
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                            },
                        });
                    },
                });
            } else {
                this.grupoFormaService.editForma(forma).subscribe({
                    next: () => {
                        this.addSuccessMessage('Forma modificada correctamente');
                        this.onBack();
                        this.visibilitySpinner = false;
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            }
        } else {
            this.grupoFormaService.createForma(forma).subscribe({
                next: res => {
                    this.addSuccessMessage('Forma añadida correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onAdd() {
        //var idForma = this.forma.Id;
        this.router.navigate([this.router.url, 'subformas', 'create']);
    }

    onEdit(item: SubFormaViewModel) {
        this.router.navigate([this.router.url, 'subformas', 'edit', item.Id]);
    }

    onDelete(item: SubFormaViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.grupoFormaService.deleteSubForma(item.Id).subscribe(res => {
                    this.addSuccessMessage('Subforma eliminada correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    onBack() {
        this.router.navigate(['/mantenimiento/especies/grupos/edit', this.forma.IdGrupo]);
    }
}
